import { createSelector } from 'reselect'

import { RootState } from './store'

const getPrivacyGuardState = (state: RootState) => state?.privacyGuard

export const getPrivacyGuardOverride = createSelector(
  getPrivacyGuardState,
  (privacyGuardState) => privacyGuardState?.override ?? null,
)
